
/*********************************************************
MediaQuery start
*********************************************************/

//document.addEventListener('DOMContentLoaded', function () {
window.addEventListener('load', function(){
  var mql = window.matchMedia('screen and (max-width: 980px)');

  function checkBreakPoint(mql) {
    if (mql.matches) {

      var controller = new ScrollMagic.Controller();
      var tl = new TimelineMax();

      /*********************************************************
      ABOUT umami page start
      *********************************************************/


      //ranking slider
      if($('#site-pages-umami .lineup-swiper-container').length){
        var rankingSwiper = new Swiper('.lineup-swiper-container', {
          //loop: true,
          autoplay: {
            delay: 2500,
            reverseDirection: false,
            disableOnInteraction: false,
          },
          slidesPerView: 1,
          spaceBetween: 60,
          slidesPerView: 1.5,
          centeredSlides : true,
          watchOverflow: true,
          setWrapperSize: true,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          virtualTranslate: false,
          grabCursor: true,
          navigation: {
            nextEl: '.lineup-next',
            prevEl: '.lineup-prev'
          },
        });
      }

      //ranking slider
      if($('.top-ranking .ranking-swiper-container').length){
        var rankingSwiperSp = new Swiper('.ranking-swiper-container', {
          //loop: true,
          autoplay: {
            delay: 2500,
            reverseDirection: false,
            disableOnInteraction: false,
          },
          slidesPerView: 1,
          spaceBetween: 60,
          slidesPerView: 1.5,
          centeredSlides : true,
          watchOverflow: true,
          setWrapperSize: true,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          virtualTranslate: false,
          grabCursor: true,
          navigation: {
            nextEl: '.top-ranking-next',
            prevEl: '.top-ranking-prev'
          },
        });
      }

      if($('#site-pages-fhc,#site-pages-umami,#site-newsdetail,#site-newslist,#site-productsdetail,#site-productslist').length){
        $('.sp-cart').addClass('fixed-active');
      }
      // products slider
      if($('.top-products .products-swiper-container').length){
        var productsSwiperSp = new Swiper('.products-swiper-container', {
        //loop: true,
        autoplay: {
          delay: 2500,
          reverseDirection: false,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 60,
        slidesPerView: 1.5,
        centeredSlides : true,
        watchOverflow: true,
        setWrapperSize: true,
        cssWidthAndHeight: true,
        visibilityFullFit: true,
        virtualTranslate: false,
        grabCursor: true,
        navigation: {
          nextEl: '.top-products-next',
          prevEl: '.top-products-prev'
        },

      });
      }

      if($('#site-pages-top').length){
        var topAboutHeightSp = $('.top-about').outerHeight(true);
        var lineup = new ScrollMagic.Scene({
              triggerElement: ".top-about",
              reverse: true,
              triggerHook: 0,
            })
            .addTo(controller)
            .setClassToggle("#sp-site-header,.sp-cart", "fixed-active")
      }

    } else {

      var controller = new ScrollMagic.Controller();
			var tl = new TimelineMax();
        $(function() {
          if($('.page-main').length){
              var pagemainHeight = $('.page-contents-area').outerHeight(true);
              var pagemain = new ScrollMagic.Scene({
                  triggerElement: ".page-main",
                  reverse: true,
                  triggerHook: 0,
                  duration: pagemainHeight - 400,
                  offset:-160,

                })
                .addTo(controller)
                .setPin(".page-side");
            }
        })


      //ranking slider
      if($('#site-pages-umami .lineup-swiper-container').length){
          var aboutrankingSwiper = new Swiper('.lineup-swiper-container', {
          //loop: true,
          slidesPerView: 3,
          spaceBetween: 60,
          watchOverflow: true,
          setWrapperSize: true,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          virtualTranslate: false,
          grabCursor: true,
          navigation: {
            nextEl: '.lineup-next',
            prevEl: '.lineup-prev'
          },
        });
      }

      /*********************************************************
      NEWS page start
      *********************************************************/
      // products detail fixed off
      if($('#site-newslist,#site-newsdetail').length){

        var productsdetailRight = new ScrollMagic.Scene({
              triggerElement: "#footer-marquee",
              reverse: true,
              triggerHook: 1,
            })
            .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
                  $('.aside-sns-navigation').removeClass('active');
            })
            .on("leave", function (event) { // シーンの状態が"DURING"から"BEFORE"か"AFTER"に移る際に発火する
                   $('.aside-sns-navigation').addClass('active');
             })
            .addTo(controller)


      }

      /*********************************************************
      PRODUCTS page start
      *********************************************************/

      if($('#site-productslist,#site-productsdetail,#site-newslist,#site-newsdetail').length){
        $('.aside-sns-navigation').addClass('active');
      }
      // products list fixed off
      if($('#site-productslist').length){
        var productsdetailRightHeight = $('.productslist-contents').outerHeight(true);
        var productsdetailRight = new ScrollMagic.Scene({
              triggerElement: "#footer-marquee",
              reverse: true,
              triggerHook: 1,
              //duration: productsdetailRightHeight,

            })
            .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
                  $('#site-productslist .aside-sns-navigation').removeClass('active');
            })
            .on("leave", function (event) { // シーンの状態が"DURING"から"BEFORE"か"AFTER"に移る際に発火する
                   $('#site-productslist .aside-sns-navigation').addClass('active');
             })
            .addTo(controller)
            .setClassToggle(".productslist", "fixed-off")

      }


      // products detail fixed off
      if($('.productsdetail-special').length){

        var productsdetailRight = new ScrollMagic.Scene({
              triggerElement: ".productsdetail-special",
              reverse: true,
              triggerHook: 1,
            })
            .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
                  $('#site-productsdetail .aside-sns-navigation').removeClass('active');
            })
            .on("leave", function (event) { // シーンの状態が"DURING"から"BEFORE"か"AFTER"に移る際に発火する
                   $('#site-productsdetail .aside-sns-navigation').addClass('active');
             })
            .addTo(controller)


      }
      // products fixed off
      if($('#site-productsdetail').length){
        var productsdetailRightHeight = $('.productsdetail-main-right').outerHeight(true);
        var productsdetailRight = new ScrollMagic.Scene({
              triggerElement: "#footer-marquee",
              reverse: true,
              triggerHook: 1,
              //duration: productsdetailRightHeight,
            })
            .addTo(controller)
            .setClassToggle(".productsdetail", "fixed-off")

      }



      //ranking slider
      if($('.top-ranking .ranking-swiper-container').length){
          var ToprankingSwiper = new Swiper('.ranking-swiper-container', {
          //loop: true,
          slidesPerView: 3,
          spaceBetween: 60,
          watchOverflow: true,
          setWrapperSize: true,
          cssWidthAndHeight: true,
          visibilityFullFit: true,
          virtualTranslate: false,
          grabCursor: true,
          navigation: {
            nextEl: '.top-ranking-next',
            prevEl: '.top-ranking-prev'
          },
        });
      }
      // products slider
      if($('.top-products .products-swiper-container').length){
          var TopproductsSwiper = new Swiper('.products-swiper-container', {
          //loop: true,
            slidesPerView: 3,
            spaceBetween: 60,
            watchOverflow: true,
            setWrapperSize: true,
            cssWidthAndHeight: true,
            visibilityFullFit: true,
            virtualTranslate: false,
            grabCursor: true,
            navigation: {
              nextEl: '.top-products-next',
              prevEl: '.top-products-prev'
            },
          });
        }

      var controller = new ScrollMagic.Controller();
			var tl = new TimelineMax();

      if($('.top-about').length){
        var topAboutHeight = $('.top-about').outerHeight(true);
        var topAbout = new ScrollMagic.Scene({
              triggerElement: ".top-about",
              reverse: true,
              triggerHook: .5,
              //duration: topAboutHeight,
            })
            .addTo(controller)
            .setClassToggle(".aside-sns-navigation", "active")
      }
      if($('.top-special').length){
        var topSpecialHeight = $('.top-special').outerHeight(true);
        var topSpecial = new ScrollMagic.Scene({
              triggerElement: ".top-special",
              reverse: true,
              triggerHook: .5,
              //duration: topSpecialHeight,

            })
            .addTo(controller)
            .setClassToggle(".aside-sns-navigation", "is-hide")

      }

      if($('.site').length){
        var toTop = new ScrollMagic.Scene({
            triggerElement: ".site-footer",
            reverse: true,
            triggerHook: 1,
          })
          .addTo(controller)
          .on("leave", function(event) {
          })
          .on("progress", function(event) {
            $("#pagetop").toggleClass('is-pagetop-fixed')
            $(".sns-navigation").toggleClass('is-hide')
          });
        }
      /*********************************************************
      TOP page end
      *********************************************************/
  }}

  mql.addListener(checkBreakPoint);
  checkBreakPoint(mql);
});


/*********************************************************
MediaQuery end
*********************************************************/



/*********************************************************
common start
*********************************************************/
var controller = new ScrollMagic.Controller();
var tl = new TimelineMax();


/*********************************************************
page start
*********************************************************/

if($('#site-pages-shopping-guide').length){

    var navLink = $('.page-side-navigation li a');
    var contentsArr = new Array();
    for (var i = 0; i < navLink.length; i++) {
      var targetContents = navLink.eq(i).attr('href');
      if (targetContents.charAt(0) == '#') {
        var targetContentsTop = $(targetContents).offset().top - 240;
        var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true);
        contentsArr[i] = [targetContentsTop, targetContentsBottom]
      }
    };

    function currentCheck() {
      var windowScrolltop = $(window).scrollTop();
      for (var i = 0; i < contentsArr.length; i++) {
        if (contentsArr[i][0] <= windowScrolltop && contentsArr[i][1] >= windowScrolltop) {
          navLink.removeClass('current');
          navLink.eq(i).addClass('current');
          i == contentsArr.length;
        }
      };
    }

    navLink.on('click', function() {
      $('html,body').stop().animate({
        scrollTop: $($(this).attr('href')).offset().top - 140
      }, 500);
      return false;
    })

    $('html,body').animate({
      scrollTop: 0
    }, '1');


    $(window).on('load ', function() {});
    $(window).on('load scroll', function() {
      currentCheck();
    });

  }


if($('#about').length){
  var aboutFhcAbout = new ScrollMagic.Scene({
        triggerElement: "#about",
        reverse: false,
        triggerHook: .5,
      })
      .addTo(controller)
      .setClassToggle(".about", "active")

}


$(window).on('load',function(){

  if($('.productsdetail-floating').length){
    // products floating active
    var productsDetailFloating = new ScrollMagic.Scene({
      triggerElement: "#productsdetail-form",
      reverse: true,
      triggerHook: 0,
    })
    .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
           $('#pagetop').addClass('active');
           $('.sp-cart').addClass('active');
    })
    .on("leave", function (event) { // シーンの状態が"DURING"から"BEFORE"か"AFTER"に移る際に発火する
          $('#pagetop').removeClass('active');
          $('.sp-cart').removeClass('active');
     })
    .addTo(controller)
    .setClassToggle(".productsdetail-floating", "active")
  }

  // products slider
  if($('.productsdetail-swiper-container').length){
      var p = new Swiper('.productsdetail-swiper-container', {
        spaceBetween: 0,
        speed: 1000,
        effect: 'fade',
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.productsdetail-next',
          prevEl: '.productsdetail-prev',
        },
      });

    }


})

$(function() {


  /*********************************************************
  top FV start
  *********************************************************/
  
  if($('.top-kv').length){
      tl.to(".top-kv", 0, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,
      })

      .to(".top-kv .title", .5, {
        className: "+=active",
        ease: Power0.easeNone,
        delay: 0,

      })

      .to("#site-header", .5, {
        className: "+=active",
        ease: Power0.easeNone,
        delay: 1,
      })
      .to(".top-kv .kv-keyword", .5, {
        className: "+=active",
        ease: Power0.easeNone,
        delay: 0,

      })
      .to(".top-kv .kv-copy", .5, {
        className: "+=active",
        ease: Power0.easeNone,
        delay: 0,

      })

      .to(".top-kv .kv-fhc", .5, {
        className: "+=active",
        ease: Power0.easeNone,
        delay: 0,

      })


  }
  /*********************************************************
  top FV end
  *********************************************************/

  /*********************************************************
  news page start
  *********************************************************/
  // news list first view
  if($('#site-newslist').length){
      tl.to(".news-header", 0, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,
      })
  }

  /*********************************************************
  Products page start
  *********************************************************/

  // products sets slider
  if($('.sets-swiper-container').length){
      var setsSwiper = new Swiper('.sets-swiper-container', {
        spaceBetween: 0,
        speed: 1000,
        //effect: 'fade',
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.sets-next',
          prevEl: '.sets-prev',
        },
      });

    }

  // products list first view
  if($('#site-productslist').length){
      tl.to(".productslist-header", 0, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,
      })
  }
  // PRODUCT DETAIL floating
  if($('.productsdetail-floating').length){
          var productsDetailFloatingH = $('.floating-bottom').outerHeight(true);
            $('.productsdetail-floating').css('transform','translateY(' + productsDetailFloatingH + 'px)');
            $('.floating-buy-button').on('click',function() {
              $('.productsdetail-floating').toggleClass('open');


                if ($('.productsdetail-floating').hasClass('open')) {
                    $('.floating-buy-button span').text('閉じる');
                    $('.productsdetail-floating').css('transform','translateY(' + 0 + 'px)')

                } else {
                    $('.floating-buy-button span').text('数量を選ぶ');
                    $('.productsdetail-floating').css('transform','translateY(' + productsDetailFloatingH + 'px)')
                }
          });
  }

  // products ranking slider
  if($('.productsdetail-ranking .ranking-swiper-container').length){
      var rankingSwiper = new Swiper('.ranking-swiper-container', {
      //loop: true,
      slidesPerView: 4,
      spaceBetween: 25,
      watchOverflow: true,
      setWrapperSize: true,
      cssWidthAndHeight: true,
      visibilityFullFit: true,
      virtualTranslate: false,
      grabCursor: true,
      navigation: {
        nextEl: '.ranking-next',
        prevEl: '.ranking-prev'
      },
      breakpoints: {
        980: {
          setWrapperSize:true,
          slidesPerView: 2.5,
          spaceBetween: 5,
          slidesOffsetBefore:10,
          slidesOffsetAfter:10
        },
        414: {
          setWrapperSize:true,
          slidesPerView: 1.6,
          spaceBetween: 5,
          slidesOffsetBefore:10,
          slidesOffsetAfter:10
        },
        320: {
          setWrapperSize:true,
          slidesPerView: 1.25,
          spaceBetween: 5,
          slidesOffsetBefore:10,
          slidesOffsetAfter:5
        },

      }
    });
  }
  // products ranking slider
  /*
  if($('.productsdetail-recent .recent-swiper-container').length){
      var recentSwiper = new Swiper('.recent-swiper-container', {
      //loop: true,
      slidesPerView: 5,
      spaceBetween: 35,
      watchOverflow: true,
      setWrapperSize: true,
      cssWidthAndHeight: true,
      visibilityFullFit: true,
      virtualTranslate: false,
      grabCursor: true,
      navigation: {
        nextEl: '.recent-next',
        prevEl: '.recent-prev'
      },
      breakpoints: {
        980: {
          setWrapperSize:true,
          slidesPerView: 3.5,
          spaceBetween: 2.5,
          slidesOffsetBefore:10,
          slidesOffsetAfter:10
        },
        414: {
          setWrapperSize:true,
          slidesPerView: 2.4,
          spaceBetween: 5,
          slidesOffsetBefore:10,
          slidesOffsetAfter:10
        },
        320: {
          setWrapperSize:true,
          slidesPerView: 2,
          spaceBetween: 5,
          slidesOffsetBefore:10,
          slidesOffsetAfter:10
        },

      }
    });

  }
  */
  /*********************************************************
  Products page end
  *********************************************************/

  /*********************************************************
  top pagetitle start
  *********************************************************/
  if( $('#site-pages-top .page-title').length ) {
    var controller = new ScrollMagic.Controller();
    $(".page-title").each(function() {
      var ramAnimeTxt = $(this).find('span i').toArray();
      var tl = new TimelineMax();


      TweenMax.set(ramAnimeTxt, {
        //autoAlpha: 0,
        y: 100,

      });
      ramAnimeTxt.sort(function() {
        return 0.5 - Math.random()
      });
      var randumTtl = TweenMax.staggerTo(ramAnimeTxt, 0.5, {
        autoAlpha: 1,
        y: 0,
        delay: .4,
        ease: Quad.easeInOut,
      }, 0.02);
        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 1,
          })
          .setTween(randumTtl).addTo(controller)
    });
  }
  /*********************************************************
  top pagetitle end
  *********************************************************/



  /*********************************************************
  top about start
  *********************************************************/
  if($('.top-about').length){
    var topAboutHeight = $('.top-about').outerHeight(true);
    var lineup = new ScrollMagic.Scene({
          triggerElement: ".top-about",
          reverse: false,
          triggerHook: .5,
          //duration: topAboutHeight,
        })
        .addTo(controller)
        .setClassToggle(".about-area", "active")

  }
  /*********************************************************
  top about end
  *********************************************************/


  /*********************************************************
  top products start
  *********************************************************/
  if($('.top-products').length){
    var topProductHeight = $('.top-products').outerHeight(true);
    var topProduct = new ScrollMagic.Scene({
          triggerElement: ".top-products",
          reverse: false,
          triggerHook: .5,
          //duration: topAboutHeight,
        })
        .addTo(controller)
        .setClassToggle(".products-area", "active")

  }
  /*********************************************************
  top products end
  *********************************************************/
  /*********************************************************
  top special start
  *********************************************************/
  if($('.top-special').length){
    var topSpecialHeight = $('.top-special').outerHeight(true);
    var lineup = new ScrollMagic.Scene({
          triggerElement: ".top-special",
          reverse: false,
          triggerHook: .5,
          //duration: topAboutHeight,
        })
        .addTo(controller)
        .setClassToggle(".special-area", "active")

  }
  /*********************************************************
  top special end
  *********************************************************/


/*********************************************************
top KV start
*********************************************************/
  //kv slider
  if($('.kv-swiper-container').length){
    var interleaveOffset = 1;
    var autoplay = 2500;
    var swiperOptions = {
        loop: true,
        autoplay: {
          delay: 2500,
          reverseDirection: true,
          disableOnInteraction: false,
        },
        reverseDirection: true,
        speed: 1500,
        grabCursor: false,
        watchSlidesProgress: true,
        mousewheelControl: false,
        keyboardControl: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        on: {
        slideChange: function() {
          $(function() {
            //$('div.swiper-num .current').text(swiperNew.realIndex + 1);
            //$('div.swiper-num .total').text(swiperNew.slides.length - 2);
            if($('#progress').length){
              slide_progress();
            }
          });
        },
        progress: function() {
          var swiper = this;
          for (var i = 0; i < swiper.slides.length; i++) {
            var slideProgress = swiper.slides[i].progress;
            var innerOffset = swiper.width * interleaveOffset;
            var innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(".slide-inner").style.transform =
              "translate3d(" + innerTranslate + "px, 0, 0)";
          }
        },
        touchStart: function() {
          var swiper = this;
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
          }
        },
        setTransition: function(speed) {
          var swiper = this;
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = speed + "ms";
            swiper.slides[i].querySelector(".slide-inner").style.transition =
              speed + "ms";
          }
        }
      }
    };
    var swiperNew = new Swiper(".kv-swiper-container", swiperOptions);

      function slide_progress() {
        var elem = document.getElementById("progress");
        var swiperWidth = 1;
        var count    = 0;
        var end      = 100;
        var interval = 25;
        var autoplayTime = interval / 100;
        var id = setInterval(

          function() {
            count++;
            if($('#progress').length){
            elem.style.width = count + '%';

            }
            if (count == end) {
                clearInterval(id);
            }
          }
          ,interval
        )
      }
    }
/*********************************************************
top KV end
*********************************************************/

/*********************************************************
top FAQ start
*********************************************************/

  //faq scroll
  if($('.top-faq').length){
    (function(abc) {
    // DOMの準備が完了した後、処理を実行
    abc(function() {
        // 処理

      $.mCustomScrollbar.defaults.scrollButtons.enable=true; //enable scrolling buttons by default
      $.mCustomScrollbar.defaults.axis="yx"; //enable 2 axis scrollbars by default
      $(".faq-contents").mCustomScrollbar();

      $(".all-themes-switch a").click(function(e){
        e.preventDefault();
        var $this=$(this),
          rel=$this.attr("rel"),
          el=$(".content");
        switch(rel){
          case "toggle-content":
            el.toggleClass("expanded-content");
            break;
          }
        });
      });
  })(jQuery);
  }
/*********************************************************
top FAQ end
*********************************************************/

});
